module.exports = __webpack_public_path__ + "img/1546658934.05cfde98.jpg";